<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    岗厦站<br>
站点介绍<br>
地铁岗厦站位于深圳市福田区福华路与彩田路交汇处，车站在福华路下方，横跨彩田路呈东西向布置。车站装修以白色为主，空间简洁明快，绿色的立柱给人以生机勃勃的感觉，简单的材料组合及明亮的灯具，打造出富有现代气息的地下空间。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:10	23:55	1号线	2分钟	4分40秒<br>
机场东	06:33	23:13	1号线	2分钟	4分40秒<br>
福田口岸	06:28	23:51	10号线	3分40秒	6分钟<br>
双拥街	06:17	23:04	10号线	3分40秒	6分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:11	23:53	1号线	3分45秒	5分45秒<br>
机场东	06:33	23:13	1号线	3分45秒	5分45秒<br>
福田口岸	06:34	23:51	10号线	4分50秒	7分钟<br>
双拥街	06:25	23:04	10号线	4分50秒	7分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:11	00:53	1号线	3分45秒	5分45秒<br>
机场东	06:33	00:13	1号线	3分45秒	5分45秒<br>
福田口岸	06:29	00:51	10号线	4分50秒	7分钟<br>
双拥街	06:17	00:04	10号线	4分50秒	7分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
彩田路东侧（北）、福华路北侧（东）、深南大道(罗湖方向)、好百年家居彩田店、深圳中心公园、岗厦村、深圳岗厦小学、彩虹大厦(彩虹新都)、海鹰大厦、文蔚大厦、邮电大厦、高科利大厦、岗厦牌坊、深大新村、福田派出所、金盾剧场<br><br>
B出入口:<br>
彩田路西侧（北）、福华路北侧（西）、星河第三空间、彩福大厦、舍＆予齿科、嘉麟豪庭、福田茶叶批发中心、星河世纪<br><br>
C出入口:<br>
彩田路西侧（南）、福华路南侧（西）、岗厦中学、辛城花园、高级技校(转公交)、 新洲村(转公交) 、 财富大厦、现代国际、深圳温德姆至尊酒店、深圳兆邦基金融大厦、路灯大厦 瀚森大厦<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 福华新村<br>
3、4、高峰专线29号、38、62、63、203、303、317、339、377、385、391、M224、M433、N10、E10、103、202、M194<br><br>
B出入口:<br>
公交站名： 岗厦地铁站<br>
3、高峰专线29号、38、62、63、M224、N10、M329、M221、M223、E20、高快巴士37号、高快巴士27号<br><br>
C出入口:<br>
公交站名： 岗厦地铁站<br>
3、高峰专线29号、38、62、63、M329、E20、M221、M223、M224、E10、高快巴士19号、高快巴士27号、80<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shihaoxian",
          title: "10号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>











